module.exports = __webpack_public_path__ + "media/images/veedelsretter-socialmedia-7af045efd1ca5f222fd6cd29bf375ab3.jpg";